import * as Yup from "yup";

export class TiposEnergiaSchema {
  public static id() {
    return Yup
      .number()
      .positive("Id deve ser um numero positivo");
  }

  public static record() {
    return Yup
      .object()
      .shape(recordShape);
  }

  public static createForm() {
    const {
      energia,
    } = recordShape;

    const createFormShape = {
      energia,
    };

    return Yup
      .object()
      .shape(createFormShape);
  }

  public static updateForm() {
    const {
      energia,
    } = recordShape;

    const updateFormShape = {
      energia,
    };

    return Yup
      .object()
      .shape(updateFormShape);
  }
}

const recordShape = {
  energia: Yup
    .string(),
};
